import {
  dealDriver
} from '@/cllib/sys_lib'

import {
  driverGetDriverList,
  driverAddDriver,
  driverUpdateDriver,
  driverDeleteDriver
} from '@/api/api'

const state = {
  driverList: [],
  driverTotal: 0
}

const getters = {
  driverList: state => state.driverList,
  driverTotal: state => state.driverTotal
}

const actions = {
  loadDriverList ({ dispatch }, parm) {
    return driverGetDriverList(parm).then((data) => {
      dispatch('setDriverList', dealDriver(data.list))
      dispatch('setDriverTotal', data.total)
    })
  },
  addDriver ({ commit }, parm) {
    return driverAddDriver(parm)
  },
  updateDriver ({ commit }, parm) {
    return driverUpdateDriver(parm)
  },
  delDriver ({ commit }, gasId) {
    return driverDeleteDriver(gasId)
  },
  setDriverList ({ commit }, data) {
    commit('setDriverList', data)
  },
  setDriverTotal ({ commit }, data) {
    commit('setDriverTotal', data)
  }
}

const mutations = {
  setDriverList (state, data) {
    state.driverList = data
  },
  setDriverTotal (state, data) {
    state.driverTotal = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base_data/driver.js